module.exports = __webpack_public_path__ + "img/happytable_info5.4627b268.jpg";